import { TicketStatus } from "interfaces/entities/ticket";

export enum TicketsBatchAction {
  MarkAsOpen,
  MarkAsPending,
  MarkAsOnHold,
  MarkAsSolved,
  MarkAsClosed,
  ChangeAssignee,
  ChangeTeam,
}

export const batchActionStatusMap = {
  [TicketsBatchAction.MarkAsOpen]: TicketStatus.Open,
  [TicketsBatchAction.MarkAsPending]: TicketStatus.Pending,
  [TicketsBatchAction.MarkAsOnHold]: TicketStatus.OnHold,
  [TicketsBatchAction.MarkAsSolved]: TicketStatus.Solved,
  [TicketsBatchAction.MarkAsClosed]: TicketStatus.Closed,
};
